import React, {useEffect, useRef, useState} from "react";
import {Card, Col, Form, Row, Button} from "react-bootstrap";
import {useFormik} from "formik";
import {Editor} from "@tinymce/tinymce-react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {Container} from "react-bootstrap";
import {useParams} from "react-router-dom";
import moment from "moment/moment";
import {getBlockById as onGetBlockById} from "../../../slices/block/thunk";
import {updateBlockList as updateNewBlock} from "../../../slices/block/thunk";
import {deleteBlockList as onDeleteBlockList} from "../../../slices/block/thunk";
import {DeleteModal} from "../../../Common/DeleteModal";
import * as Yup from "yup";

const UpdatePages = () => {
    document.title = "Update Pages";
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const navigate = useNavigate();
    const dispatch = useDispatch<any>();
    const {lang} = useParams();

    const pagesData = useSelector((state: any) => state.Block.block);
    const [edit, setEdit] = useState<boolean>(false);
    const [isEditorReady, setIsEditorReady] = useState(false);
    const [pageLists, setPageLists] = useState<any>(null);
    const [show, setShow] = useState<boolean>(false);
    const [editContent, setEditContent] = useState(
        {
            title: "",
            url: '',
            shortInfo: '',
            status: '',
            publishedAt: ''
        }
    );

    const editorRef = useRef<{
        getContent: () => string;
        setContent: (content: string) => void;
    } | null>(null);

    const handleEditorInit = (_evt: any, editor: any) => {
        editorRef.current = editor;
        setIsEditorReady(true);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: editContent.title || '',
            url: editContent.url || '',
            status: editContent.status || 'ENABLE',
        },

        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your Product Name"),
            url: Yup.string().required("Please Enter Your Category Image"),
        }),

        onSubmit: async (values) => {
            const data = {
                id: id,
                title: values.title,
                content: editorRef.current ? editorRef.current.getContent() : "",
                url: values.url,
                type: "PAGE",
            }

            dispatch(updateNewBlock({formData: data, id: id}));
        }
    });

    useEffect(() => {
        if (id) {
            dispatch(onGetBlockById(id));
        }
    }, [dispatch, lang]);

    useEffect(() => {
        if (Object.keys(pagesData).length > 0 && id) {
            setEditContent((editContent: any) => ({
                ...editContent,
                title: pagesData.title,
                img: pagesData.image,
                url: pagesData.url,
                shortInfo: pagesData.shortInfo,
                status: pagesData.status,
                publishedAt: moment(pagesData.publishedAt, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm"),

            }));
            setEdit(true);
            if (isEditorReady) {
                editorRef.current?.setContent(pagesData.content || "<p></p>");
            }
        }
    }, [pagesData, isEditorReady]);

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setPageLists(ele);
    };
    const handleDeleteClose = () => {
        setShow(false);
    }
    //delete modal
    const deleteModalFunction = () => {
        const deleteData = pageLists.id || {};
        if (deleteData) {
            dispatch(onDeleteBlockList(deleteData))
                .unwrap()
                .then(() => {
                    navigate(`/${lang}/pages`);
                })
                .catch((err: any) => {
                    console.error("O‘chirishda xatolik:", err);
                });
        }
        setShow(false);
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form autoComplete="off" onSubmit={formik.handleSubmit} className={"container-fluid m-auto"}>
                        <Row>
                            <Col xxl={8}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title as="h5" className="mb-3">Pages Information:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="title">Title <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="title"
                                                name="title"
                                                placeholder="title"
                                                value={formik.values.title}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.title}/>
                                            {formik.errors.title && formik.touched.title ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.title}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Form.Label htmlFor="url">URL <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="url"
                                                name="url"
                                                placeholder="url"
                                                value={formik.values.url}
                                                onChange={(e) => {
                                                    let newValue = e.target.value
                                                        .replace(/['"@#$%&*\+/`~‘\s]/g, '')
                                                        .slice(0, 60);
                                                    formik.setFieldValue("url", newValue);

                                                }}
                                                onBlur={formik.handleBlur}
                                                onFocus={() => {
                                                    if (!formik.values.url) {
                                                        let res = formik.values.title.toLowerCase();
                                                        let res1 = res.replace(/['"@#$%&*-+/`~‘’]/g, '');
                                                        let res2 = res1.replace(/\s+/g, '-');
                                                        res2 = res2.substring(0, 60);
                                                        formik.setFieldValue("url", res2);
                                                    }
                                                }}
                                                isInvalid={!!formik.errors.url}
                                            />
                                            {formik.errors.url && formik.touched.url ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.url}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <Card.Title className="mb-3">Content:</Card.Title>
                                        <Editor
                                            apiKey="w2591d9d184qpiiwjaedpr8axuqv7asojqnhwu12bh5gz8yo"
                                            onInit={handleEditorInit}
                                            initialValue="<p></p>"
                                            init={{
                                                height: 500,
                                                plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table wordcount help quickbars emoticons',
                                                imagetools_cors_hosts: 'picsum.photos',
                                                menubar: 'file edit view insert format tools table help',
                                                toolbar:
                                                    'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | source code | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor removeformat | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl',
                                                content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size: 14px }',
                                            }}
                                        />

                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xxl={4}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title className="mb-3">Details:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>

                                        <div className="mb-3">
                                            <Form.Label
                                                htmlFor="pagesStatusd">Status</Form.Label>
                                            <Form.Select
                                                id="pagesStatusd"
                                                name="status"
                                                value={formik.values.status}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.status}>
                                                <option value="ENABLE">Enable</option>
                                                <option value="DISABLE">Disabled</option>
                                                <option value="BLOCKED">Blocked</option>
                                                <option value="PUBLISHED">published</option>
                                                <option value="DRAFT">draft</option>
                                            </Form.Select>
                                            {formik.errors.status && formik.touched.status ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.status} </Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                    </Card.Body>
                                    <Card.Footer>
                                        <div className="hstack justify-content-between mb-3">
                                            <Button variant="danger" className={"d-flex align-items-center gap-1"}
                                                    onClick={() => {
                                                        handleDeleteShow(pagesData)
                                                    }}>
                                                <i className="ph-trash"></i>
                                                <span>Delete</span>
                                            </Button>
                                            <Button type={"submit"} variant="primary">
                                                {edit ? "Update Pages" : "Create Pages"}
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
            <ToastContainer/>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>
        </React.Fragment>
    )
}

export default UpdatePages;